import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AppComponent } from './app.component';
import { ClarityModule, ClrFormsNextModule } from '@clr/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { EventListComponent } from './screens/event-list/event-list.component';
import { EventService } from './services/event.service';
import { ShoppingCartService } from './services/shopping-cart.service';
import { DancerService } from './services/dancer.service';
import { CheckoutComponent } from './screens/checkout/checkout.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PaymentSelectionComponent } from './screens/payment/components/payment-selection/payment-selection.component';
import {UserService} from './services/user.service';
import { PaymentCalculationComponent } from './screens/payment/components/payment-calculation/payment-calculation.component';
import { PaymentComponent } from './screens/payment/payment.component';
import {HttpClientModule} from '@angular/common/http';
import {PaysonPaymentService} from './services/payson-payment.service';
import { PaysonPaymentComponent } from './screens/payment/components/payson-payment/payson-payment.component';
import { SanitizePipe } from './pipes/sanitize.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StripePaymentComponent } from './screens/payment/components/stripe-payment/stripe-payment.component';
import { NgxStripeModule } from 'ngx-stripe';
import { CookieService } from 'ngx-cookie-service';
import { PaymentService } from './services/payment.service';
import { IterablePipe } from 'src/app/pipes/map.pipe';
import { ScripthackComponent } from './utils/scripthack/scripthack.component';
import {MatCheckboxModule, MatSnackBarModule} from '@angular/material';
import {StripePaymentService} from './services/stripe-payment.service';
import { SwishPaymentComponent } from './screens/payment/components/swish-payment/swish-payment.component';
import {MatCardModule} from '@angular/material/card';
import { NgxSpinnerModule } from 'ngx-spinner';
import {SwishPaymentService} from './services/swish-payment.service';
import { SwishConfirmationComponent } from './screens/confirmation/swish-confirmation/swish-confirmation.component';
import { GeneralErrorComponent } from './screens/exception/general-error/general-error.component';
import { SwishExceptionComponent } from './screens/exception/swish-exception/swish-exception.component';
import { GeneralConfirmationComponent } from './screens/confirmation/general-confirmation/general-confirmation.component';
import { YoutubeComponent } from './components/youtube';
import { EventDetailComponent } from './screens/event-detail/event-detail.component';
import { ShoppingCartComponent } from './components/shoppint-cart/shopping-cart.component';
import { AgreementsComponent } from './screens/agreements/agreements.component';
import { routing } from './app.routing';
import { CustomerLayoutComponent } from './layout/customer-layout/customer-layout.component';
import { CustomerHeaderComponent } from './layout/customer-header/customer-header.component';
import { CustomerFooterComponent } from './layout/customer-footer/customer-footer.component';
import { HomeComponent } from './screens/home/home.component';
import { PaysonConfirmationComponent } from './screens/confirmation/payson-confirmation/payson-confirmation.component';
import { AboutComponent } from './screens/about/about.component';
import { DancestoreLayoutComponent } from './layout/dancestore-layout/dancestore-layout.component';
import { DancestoreHeaderComponent } from './layout/dancestore-header/dancestore-header.component';
import { DancestoreFooterComponent } from './layout/dancestore-footer/dancestore-footer.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { YTPlayerModule, YTPlayerConfig } from 'angular-youtube-player';
import {HttpClient} from '@angular/common/http';
import {MatMenuModule} from '@angular/material/menu';
import { Truncate } from './pipes/truncate.pipe';
// import { SelectDancerComponent } from './screens/select-dancer/select-dancer.component';



@NgModule({
  declarations: [
    AppComponent,
    EventListComponent,
    CheckoutComponent,
    PaymentSelectionComponent,
    PaymentCalculationComponent,
    PaymentComponent,
    PaysonPaymentComponent,
    SanitizePipe,
    SafeUrlPipe,
    SafeHtmlPipe,
    StripePaymentComponent,
    IterablePipe,
    Truncate,
    ScripthackComponent,
    SwishPaymentComponent,
    SwishConfirmationComponent,
    GeneralErrorComponent,
    SwishExceptionComponent,
    GeneralConfirmationComponent,
    YoutubeComponent,
    EventDetailComponent,
    ShoppingCartComponent,
    AgreementsComponent,
    CustomerLayoutComponent,
    CustomerHeaderComponent,
    CustomerFooterComponent,
    HomeComponent,
    PaysonConfirmationComponent,
    AboutComponent,
    DancestoreLayoutComponent,
    DancestoreHeaderComponent,
    DancestoreFooterComponent,
    // SelectDancerComponent
  ],
  imports: [
    routing,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ClarityModule,
    ClrFormsNextModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase, 'event-pos'),
    AngularFirestoreModule,
    HttpClientModule,
    MatSnackBarModule,
    NgxStripeModule.forRoot(environment.stripe_key),
    MatCardModule,
    NgxSpinnerModule,
    MatCheckboxModule,
    MatTabsModule,
    MatMenuModule,
    BrowserModule,
    YTPlayerModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],

  providers: [EventService,
    ShoppingCartService,
    DancerService,
    UserService,
    PaymentService,
    PaysonPaymentService,
    CookieService,
    StripePaymentService,
    SwishPaymentService,
    { provide: YTPlayerConfig, useValue: { shouldLoadAPI: true, multiplePlaying: true } },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
